import { gql } from '@apollo/client'
import { teamFragment } from './team'
import { gamePlatformStatus } from './game-platform-status'

const userBettingStatus = gql`
  fragment UserBettingStatus on UserBettingStatus {
    game
    status
  }
`

const platformIdentifiers = gql`
  fragment PlatformIdentifiers on PlatformIdentifier {
    gamerTag
    platform
    metadata {
      twitchVodEnabled
      streamBitrate
      streamHeight
      streamQuality
      streamQualityUpdatedAt
      twitchStreamLiveStatus
      twitchOnboardingComplete
      twitchStreamLink
      twitchProfile {
        profileImageUrl
      }
    }
  }
`

export const userFragment = gql`
  fragment User on User {
    id
    loungeUsername
    loungeUsernameLastUpdatedAt
    activeTeam {
      ...Team
    }
    platformIdentifiers {
      ...PlatformIdentifiers
    }
    gamePlatformStatus {
      ...GamePlatformStatus
    }
    userBettingStatus {
      ...UserBettingStatus
    }
    referralCodes {
      active
      code
    }
  }
  ${teamFragment}
  ${platformIdentifiers}
  ${gamePlatformStatus}
  ${userBettingStatus}
`
